import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { MakeOrderWrongWarehouseLine, MakeOrderWrongWarehouseRefusal } from '../../models';

/**
 * The words for the API's coded receipt refusals, in one place because several receipt screens show
 * them - the single receipt, Multi Select and Production Item. The API sends codes and data, not
 * prose (api.md, the shape of a refusal), so the text is worded - and translated - here. Add the
 * next coded receipt refusal here rather than wording it on a screen.
 */
@Injectable({
  providedIn: 'root',
})
export class ReceiptRefusalService {
  /**
   * The `{ code: 'MakeOrderWrongWarehouse', lines }` refusal in words, or null for any other error.
   * A make order line is received where its fabric is (4Spaces PO 500723, received into SWISS
   * DESPATCH with its fabric cut in Italy; Derek, 5 Oct 2026: hard block, no override).
   */
  makeOrderWrongWarehouse(error: HttpErrorResponse): MakeOrderWrongWarehouseRefusal | null {
    if (error?.error?.code !== 'MakeOrderWrongWarehouse') {
      return null;
    }

    const lines: MakeOrderWrongWarehouseLine[] = error.error.lines ?? [];
    const message = lines
      .map(
        (line) =>
          $localize`${line.orderAndLineNo} cannot be received into '${line.receivingWarehouse}': its fabric is in '${line.fabricWarehouses}'. Receive it into '${line.fabricWarehouses}'.`,
      )
      .join(' ');

    return { lines, message };
  }
}
